module.exports = __webpack_public_path__ + "img/COPY.f2163ac6.svg";